import GuidUtils from '@/shared/utils/guid'

export default class BenefitType {
  constructor({
    id,
    name
  } = {}) {
    this.id = id || GuidUtils.emptyGuid,
    this.name = name
  }
}